import React from "react";
import { StoryblokBlockComponent } from "../../lib/storyblok/types/StoryblokComponent";
import ContactUi from "../../ui/Contact";
import { ContactBlock } from "../../lib/storyblok/types/blocks/ContactBlock";
import StoryblokImage from "../StoryblokImage";
import { isValidImageData } from "../../lib/utils/imageUtils";

const Contact: StoryblokBlockComponent<ContactBlock> = ({
  heading,
  image,
  name,
  title,
  email,
  phone,
}) => (
  <ContactUi
    heading={heading}
    image={
      isValidImageData(image) && (
        <StoryblokImage
          sizes="100vw"
          resize={{ width: 240 }}
          image={image}
          layout="fill"
          alt={title}
        />
      )
    }
    name={name}
    title={title}
    email={email}
    phone={phone}
  />
);

export default Contact;
